
// from french azerty to us international
export const FRENCH_AZERTY_MAPPING = {
    KeyA: { value: 'KEY_Q', symbol: 'Q' },
    KeyB: { value: 'KEY_B', symbol: 'B' },
    KeyC: { value: 'KEY_C', symbol: 'C' },
    KeyD: { value: 'KEY_D', symbol: 'D' },
    KeyE: { value: 'KEY_E', symbol: 'E' },
    KeyF: { value: 'KEY_F', symbol: 'F' },
    KeyG: { value: 'KEY_G', symbol: 'G' },
    KeyH: { value: 'KEY_H', symbol: 'H' },
    KeyI: { value: 'KEY_I', symbol: 'I' },
    KeyJ: { value: 'KEY_J', symbol: 'J' },
    KeyK: { value: 'KEY_K', symbol: 'K' },
    KeyL: { value: 'KEY_L', symbol: 'L' },
    KeyM: { value: 'KEY_M', symbol: ',' },
    KeyN: { value: 'KEY_N', symbol: 'N' },
    KeyO: { value: 'KEY_O', symbol: 'O' },
    KeyP: { value: 'KEY_P', symbol: 'P' },
    KeyQ: { value: 'KEY_A', symbol: 'A' },
    KeyR: { value: 'KEY_R', symbol: 'R' },
    KeyS: { value: 'KEY_S', symbol: 'S' },
    KeyT: { value: 'KEY_T', symbol: 'T' },
    KeyU: { value: 'KEY_U', symbol: 'U' },
    KeyV: { value: 'KEY_V', symbol: 'V' },
    KeyW: { value: 'KEY_Z', symbol: 'W' },
    KeyX: { value: 'KEY_X', symbol: 'X' },
    KeyY: { value: 'KEY_Y', symbol: 'Y' },
    KeyZ: { value: 'KEY_W', symbol: 'Z' },

    Digit1: { value: 'KEY_1', symbol: '&' },
    Digit2: { value: 'KEY_2', symbol: 'é' },
    Digit3: { value: 'KEY_3', symbol: '"' },
    Digit4: { value: 'KEY_4', symbol: '\'' },
    Digit5: { value: 'KEY_5', symbol: '(' },
    Digit6: { value: 'KEY_6', symbol: '§' },
    Digit7: { value: 'KEY_7', symbol: 'è' },
    Digit8: { value: 'KEY_8', symbol: '!' },
    Digit9: { value: 'KEY_9', symbol: 'ç' },
    Digit0: { value: 'KEY_0', symbol: 'à' },

    Enter: { value: 'KEY_ENTER', symbol: 'Enter' },
    Escape: { value: 'KEY_ESC', symbol: 'Esc' },
    Backspace: { value: 'KEY_BACKSPACE', symbol: 'Delete' },
    Tab: { value: 'KEY_TAB', symbol: 'Tab' },
    Space: { value: 'KEY_SPACE', symbol: 'Space' },
    Minus: { value: 'KEY_MINUS', symbol: ')' },
    Equal: { value: 'KEY_EQUAL', symbol: '-' },
    BracketLeft: { value: 'KEY_LEFTBRACE', symbol: '^' },
    BracketRight: { value: 'KEY_RIGHTBRACE', symbol: '$' },
    Backslash: { value: 'KEY_BACKSLASH', symbol: '`' },
    IntlBackslash: { value: 'KEY_HASHTILDE', symbol: '<' },
    Semicolon: { value: 'KEY_SEMICOLON', symbol: 'm' },
    Quote: { value: 'KEY_APOSTROPHE', symbol: 'ù' },
    Backquote: { value: 'KEY_GRAVE', symbol: '@' },
    Comma: { value: 'KEY_COMMA', symbol: ';' },
    Period: { value: 'KEY_DOT', symbol: ':' },
    Slash: { value: 'KEY_SLASH', symbol: '=' },
    CapsLock: { value: 'KEY_CAPSLOCK', symbol: 'CapsLock' },

    F1: { value: 'KEY_F1', symbol: 'F1' },
    F2: { value: 'KEY_F2', symbol: 'F2' },
    F3: { value: 'KEY_F3', symbol: 'F3' },
    F4: { value: 'KEY_F4', symbol: 'F4' },
    F5: { value: 'KEY_F5', symbol: 'F5' },
    F6: { value: 'KEY_F6', symbol: 'F6' },
    F7: { value: 'KEY_F7', symbol: 'F7' },
    F8: { value: 'KEY_F8', symbol: 'F8' },
    F9: { value: 'KEY_F9', symbol: 'F9' },
    F10: { value: 'KEY_F10', symbol: 'F10' },
    F11: { value: 'KEY_F11', symbol: 'F11' },
    F12: { value: 'KEY_F12', symbol: 'F12' },
    F13: { value: 'KEY_F13', symbol: 'F13' },
    F14: { value: 'KEY_F14', symbol: 'F14' },
    F15: { value: 'KEY_F15', symbol: 'F15' },
    F16: { value: 'KEY_F16', symbol: 'F16' },
    F17: { value: 'KEY_F17', symbol: 'F17' },
    F18: { value: 'KEY_F18', symbol: 'F18' },
    F19: { value: 'KEY_F19', symbol: 'F19' },
    F20: { value: 'KEY_F20', symbol: 'F20' },
    F21: { value: 'KEY_F21', symbol: 'F21' },
    F22: { value: 'KEY_F22', symbol: 'F22' },
    F23: { value: 'KEY_F23', symbol: 'F23' },
    F24: { value: 'KEY_F24', symbol: 'F24' },

    PrintScreen: { value: 'KEY_SYSRQ', symbol: 'PrintScreen' },
    ScrollLock: { value: 'KEY_SCROLLLOCK', symbol: 'Scroll Lock' },
    Pause: { value: 'KEY_PAUSE', symbol: 'Pause' },
    Insert: { value: 'KEY_INSERT', symbol: 'Insert' },
    Home: { value: 'KEY_HOME', symbol: 'Home' },
    PageUp: { value: 'KEY_PAGEUP', symbol: 'Page Up' },
    Delete: { value: 'KEY_DELETE', symbol: 'Suppr' },
    End: { value: 'KEY_END', symbol: 'End' },
    PageDown: { value: 'KEY_PAGEDOWN', symbol: 'Page Down' },
    ArrowRight: { value: 'KEY_RIGHT', symbol: 'Right' },
    ArrowLeft: { value: 'KEY_LEFT', symbol: 'Left' },
    ArrowDown: { value: 'KEY_DOWN', symbol: 'Down' },
    ArrowUp: { value: 'KEY_UP', symbol: 'Up' },

    // Keyboard keypad
    NumLock: { value: 'KEY_NUMLOCK', symbol: 'NumLock' },
    NumpadDivide: { value: 'KEY_KPSLASH', symbol: 'Keypad /' },
    NumpadMultiply: { value: 'KEY_KPASTERISK', symbol: 'Keypad *' },
    NumpadSubtract: { value: 'KEY_KPMINUS', symbol: 'Keypad -' },
    NumpadAdd: { value: 'KEY_KPPLUS', symbol: 'Keypad +' },
    NumpadEnter: { value: 'KEY_KPENTER', symbol: 'Keypad Enter' },
    Numpad1: { value: 'KEY_KP1', symbol: 'Keypad 1' },
    Numpad2: { value: 'KEY_KP2', symbol: 'Keypad 2' },
    Numpad3: { value: 'KEY_KP3', symbol: 'Keypad 3' },
    Numpad4: { value: 'KEY_KP4', symbol: 'Keypad 4' },
    Numpad5: { value: 'KEY_KP5', symbol: 'Keypad 5' },
    Numpad6: { value: 'KEY_KP6', symbol: 'Keypad 6' },
    Numpad7: { value: 'KEY_KP7', symbol: 'Keypad 7' },
    Numpad8: { value: 'KEY_KP8', symbol: 'Keypad 8' },
    Numpad9: { value: 'KEY_KP9', symbol: 'Keypad 9' },
    Numpad0: { value: 'KEY_KP0', symbol: 'Keypad 0' },
    NumpadDecimal: { value: 'KEY_KPDOT', symbol: 'Keypad .' },
    NumpadEqual: { value: 'KEY_KPEQUAL', symbol: 'Keypad =' },

    ControlLeft: { value: 'KEY_LEFTCTRL', symbol: 'Ctrl Left' },
    ShiftLeft: { value: 'KEY_LEFTSHIFT', symbol: 'Shift Left' },
    AltLeft: { value: 'KEY_LEFTALT', symbol: 'Alt Left' },
    MetaLeft: { value: 'KEY_LEFTMETA', symbol: 'Meta Left' },
    ControlRight: { value: 'KEY_RIGHTCTRL', symbol: 'Ctrl Right' },
    ShiftRight: { value: 'KEY_RIGHTSHIFT', symbol: 'Shift Right' },
    AltRight: { value: 'KEY_RIGHTALT', symbol: 'Alt Right' },
    MetaRight: { value: 'KEY_RIGHTMETA', symbol: 'Meta Right' },
}
